module.exports = __webpack_public_path__ + "img/AEON.bf87c60d.svg";